import React, { Component } from 'react';
import Routes from './Routes';
import { Provider as StoreProvider } from 'mobx-react';
import { getInstanceStores } from './stores/Store';
import {enableLogging} from 'mobx-logger';
require('./common/events/listeners');

let enableMobxTracker = false;
const config = { 
    predicate: () => enableMobxTracker,
    action: true,
    reaction: true,
    transaction: true,
    compute: true
};
enableLogging(config);

class App extends Component {
  render() {
    return (
      <StoreProvider {...getInstanceStores()}>
        <Routes />
      </StoreProvider>
    )
  }  
}

export default App



// WEBPACK FOOTER //
// ./src/app/App.js